import {
  RichiestaPubblicaDto,
  RichiestaPubblicaDtoRichiesta,
} from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { DividerTitleElement, ISODate, VerticalSpace } from '@framework/ui';
import { Col, Row } from 'antd';
import React from 'react';
import { DescriptionItem } from './DescriptionItem';

export interface IProcedureDataViewProps {
  submission?: RichiestaPubblicaDtoRichiesta;
  osservation?: RichiestaPubblicaDto;
}

/**
 * ...
 */
export function ProcedureDataView(props: IProcedureDataViewProps) {
  const { submission, osservation } = props;
  const { t } = useTranslation();

  if (!submission) return null;

  return (
    <div>
      <DividerTitleElement
        title={t(
          'observation.dati-del-procedimento',
          'Dati del Procedimento',
        )}
        removeTopMargin
      />
      <Row>
        <Col span={12}>
          {submission?.oggetto && (
            <DescriptionItem
              label={t('observation.procedimento', 'Procedimento')}
              value={submission?.oggetto ?? '–'}
            />
          )}
        </Col>
        <Col span={6}>
          <DescriptionItem
            label={t(
              'observation.numero-protocollo',
              'Numero Protocollo',
            )}
            value={submission?.numeroProtocollo ?? '–'}
          />
        </Col>
        <Col span={6}>
          <DescriptionItem
            label={t('observation.data-protocollo', 'Data Protocollo')}
            value={
              submission?.dataProtocollo ? (
                <ISODate date={submission?.dataProtocollo ?? '–'} />
              ) : (
                '–'
              )
            }
          />
        </Col>
      </Row>
      <VerticalSpace size={12} />
      <Row>
        <Col span={12}>
          <DescriptionItem
            label={t(
              'observation.ufficio-responsabile',
              'Ufficio Responsabile',
            )}
            value={osservation?.ufficioResponsabile?.denominazione ?? '–'}
          />
        </Col>
        <Col span={6}>
          <DescriptionItem
            label={t(
              'observation.inizio-osservazione',
              'Inizio Osservazione',
            )}
            value={<ISODate date={osservation?.dataInizioOsservazione} />}
          />
        </Col>
        <Col span={6}>
          <DescriptionItem
            label={t(
              'observation.fine-osservazione',
              'Fine Osservazione',
            )}
            value={<ISODate date={osservation?.dataFineOsservazione} />}
          />
        </Col>
      </Row>
    </div>
  );
}
